import { FormCard } from '@qbe/ads-blocks-forms';
import React from 'react';

import CoverSelector from '~/components/CoverSelector';
import { useAppContent } from '~/hooks';
import { useTrackOptimizeActivate } from '~/hooks/useTrackOptimizeActivate';

const SelectCover: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.selectCover' });
  // Tracks the "optimize.activate" event when the component mounts or re-renders.
  // This is used to notify Webtrends (or other analytics tools) for visibility tracking
  // and ensures dynamic content is properly handled.
  useTrackOptimizeActivate();
  return (
    <>
      <FormCard
        variant="pageTitle"
        title={getTextContent('title')}
        description={getTextContent('description')}
      />

      <FormCard variant="content">
        <CoverSelector />
      </FormCard>
    </>
  );
};

export default SelectCover;
